export var defaultSpacing = 8;
export var spacing = {
  xs: 2,
  // default / 2
  s: 8,
  // 8
  m: 16,
  // defaultSpacing * 2,
  l: 24,
  // defaultSpacing * 3,
  xl: 32,
  // defaultSpacing * 4,
  xxl: 40 // defaultSpacing * 5,

};